<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>运单管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>任务单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">创建日期</span>
        <el-date-picker
          v-model="filter.startTime"
          type="datetime"
          placeholder="选择开始时间"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="filter.endTime"
          type="datetime"
          placeholder="选择结束时间"
          default-time="23:59:59"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="item-label">筛选条件</span>
        <el-input
          v-model.trim="filter.keyword"
          style="width: 210px"
          :maxlength="ordernumberKeywordLimit"
          placeholder="搜索任务单号、车牌号、司机"
        >
        </el-input>
      </div>

      <div class="toolbar-item" id="auto-2">
        <span class="item-label">装货城市</span>
        <div class="inlineblock">
          <select-city
            type="ZH"
            @select-city="selectSourceCity"
            :clearable="true"
            width="150px"
            placeholder="请选择装货城市"
          ></select-city>
        </div>
      </div>
      <div class="toolbar-item" id="auto-3">
        <span class="item-label">卸货城市</span>
        <div class="inlineblock">
          <select-city
            type="XH"
            @select-city="selectTargetCity"
            :clearable="true"
            width="150px"
            placeholder="请选择卸货城市"
          ></select-city>
        </div>
      </div>
      <div v-if="roleRules.indexOf('SJB_P_0006') != -1" class="toolbar-item" id="auto-4">
        <span class="item-label">下单人</span>
        <el-select
          style="width: 150px"
          v-model="filter.intermediary"
          placeholder="请选择"
          class="track-elselect"
          clearable
        >
          <el-option v-for="(item, idx) in roleArr" :label="item.userName" :value="item.userCode" :key="idx">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-5">
        <span class="item-label">任务状态</span>
        <el-select
          style="width: 120px"
          v-model="filter.filterState"
          placeholder="请选择"
          class="track-elselect"
          clearable
        >
          <el-option v-for="item in taskState" :label="item.label" :value="item.value" :key="item.value"> </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-6">
        <span class="item-label">装货地址</span>
        <el-input
          v-model.trim="filter.sourceName"
          style="width: 240px"
          :maxlength="addressKeywordLimit"
          placeholder="请输入装货地地址"
        >
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-7">
        <span class="item-label">卸货地址</span>
        <el-input
          v-model.trim="filter.targetName"
          style="width: 240px"
          :maxlength="addressKeywordLimit"
          placeholder="请输入卸货地地址"
        >
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-14">
        <span class="item-label">磅单上传方式</span>
        <el-select
          style="width: 120px"
          v-model="filter.poundUploadType"
          placeholder="请选择"
          class="track-elselect"
          clearable
        >
          <el-option v-for="item in poundTypeList" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-8">
        <el-button type="primary" size="small" @click="screen">筛选</el-button>
      </div>
    </div>
    <div class="task-tips-con mb-20 mt-20" v-if="enterprisenature == 1">
      <span class="task-tips-text-weight"></span>待司机确认：<span class="font-red" id="auto-9">{{
        orderScheduleWaitSum
      }}</span
      >； <span class="task-tips-text-weight"></span>进行中任务数：<span class="font-red" id="auto-9">{{
        processingOrderScheduleSum
      }}</span
      >； <span class="task-tips-text-weight"></span>结束未传：<span class="font-red" id="auto-15">{{
        finishUnuploadNum
      }}</span
      >； <span class="task-tips-text-weight"></span>待匹配：<span class="font-red" id="auto-16">{{ matchingNum }}</span
      >； <span class="task-tips-text-weight"></span>驳回检查：<span class="font-red" id="auto-17">{{ rejectNum }}</span
      >；
      <span class="click-link" @click="goToAbnormalCar"
        >异常车辆数：<span class="font-red" id="auto-10">{{ orderScheduleAbnormalVehicleSum }}</span
        >；</span
      ><span class="click-link" @click="goToAbnormalOrder" id="auto-11"
        >异常运单数：<span class="font-red" id="auto-12">{{ orderScheduleAbnormalOrderSum }}</span></span
      >；
    </div>
    <div class="table-custom-box mt-10" id="auto-13">
      <el-table :data="tableData.list" border>
        <el-table-column width="40" type="expand">
          <template v-slot="scope">
            <el-form label-position="left" inline class="self-table-expand">
              <el-form-item label="任务单创建时间">
                <span>{{ scope.row.createTime | stamp2TextDateFull(2) }}</span>
              </el-form-item>
              <el-form-item label="司机手机号">
                <span>{{ scope.row.driverPhone }}</span>
              </el-form-item>
              <el-form-item label="货物类型">
                <span>{{ scope.row.stockKind }}</span>
              </el-form-item>
              <el-form-item label="委托派车">
                <span v-if="scope.row.entrust">是</span>
                <span v-else>否</span>
              </el-form-item>
              <el-form-item label="支付方式">
                <div>
                  <span>{{ scope.row.payMentType | getPaymenttype }}</span>
                </div>
              </el-form-item>
              <el-form-item label=" ">
                <span></span>
              </el-form-item>

              <div>
                <el-tag class="mr-10" type="info" v-if="scope.row.checkETC">ETC</el-tag>
                <el-tag class="mr-10" type="info" v-if="scope.row.checkOil">油费</el-tag>
                <el-tag class="mr-10" type="info" v-if="scope.row.checkAgent">经纪人</el-tag>
                <el-tag class="mr-10" type="info" v-if="scope.row.checkCaptainDriver">车队长</el-tag>
              </div>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="orderschedulecole" label="任务单号" min-width="120">
          <template v-slot="scope">
            <span v-if="scope.row.orderScheduleType === 1">{{ scope.row.orderScheduleCode }}</span>
            <span class="font-green pointer" @click="taskDetail(scope.row)" v-if="scope.row.orderScheduleType === 2">{{
              scope.row.orderScheduleCode
            }}</span>
            <div>
              <img
                class="guarantee-tag mr-5"
                v-if="scope.row.isCargoGuarantee === 1"
                src="../../assets/img/order/tag_list_hwbz14@2x.png"
                alt=""
              />
              <img
                class="isinsurance-tag"
                v-if="scope.row.isInsurance === 1"
                src="../../assets/img/order/tag_list_ydtb14@2x.png"
                alt=""
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="statetxt" label="任务状态" min-width="90">
          <template v-slot="scope">
            <div
              :class="{
                'font-green': scope.row.state == 2 || scope.row.state == 3,
                'font-orange': scope.row.state == 1 || scope.row.state == 4
              }"
            >
              {{ scope.row.stateName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="磅单上传方式" min-width="70">
          <template v-slot="scope">
            <span v-if="scope.row.poundUploadType == 1">批量上传</span>
            <span v-if="scope.row.poundUploadType == 2">按趟上传</span>
          </template>
        </el-table-column>
        <el-table-column prop="transportTimes" label="有效趟次" min-width="70"> </el-table-column>
        <el-table-column label="装货地" min-width="125">
          <template v-slot="scope">
            <div class="text-ellipsis" :title="scope.row.loadName">{{ scope.row.loadName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="卸货地" min-width="125">
          <template v-slot="scope">
            <div class="text-ellipsis" :title="scope.row.uploadName">{{ scope.row.uploadName }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="stockUnit" label="重量/体积" min-width="90"> </el-table-column>
        <el-table-column prop="driverName" label="承运司机" min-width="90"> </el-table-column>
        <el-table-column prop="plateNum" label="车牌号码" min-width="90"> </el-table-column>
        <el-table-column label="下单" min-width="80">
          <template v-slot="scope">
            <div class="text-ellipsis" :title="scope.row.holderName">{{ scope.row.holderName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="70" align="center">
          <template v-slot="scope">
            <el-button
              type="text"
              v-if="scope.row.state == 1 && scope.row.orderScheduleType == 1"
              class="font-size12 font-blue"
              @click="handleConfirm(scope.row)"
              >结束任务</el-button
            >
            <el-button
              type="text"
              class="font-size12 font-blue"
              v-if="scope.row.readOrder"
              @click="showDetail(scope.row)"
              >查看运单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentpage"
        :total="tableData.count"
        @current-change="currentChange"
        layout="total, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:17
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import dateLimit from '@/api/dateLimit';
var SelectCity = function (resolve) {
  require(['@/components/SelectCity.vue'], resolve);
};
export default {
  data: function () {
    return {
      timeRange: '',
      currentpage: 1,
      pageSize: 20,
      isadmin: true,
      toolexpand: false,
      companycode: '',
      holdercode: '',
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      },
      filter: {
        startTime: new Date(dateLimit.getThreeMonth()).getTime(),
        endTime: dateLimit.currentDayEnd.getTime(),
        keyword: '',
        sourceCode: '',
        targetCode: '',
        sourceName: '',
        targetName: '',
        intermediary: '',
        filterState: '',
        companyCode: WUYI.currentData.company.companycode,
        poundUploadType: ''
      }, //筛选条件
      cache: {}, //缓存筛选条件
      roleArr: [],
      regionArr: [],
      taskState: [
        { label: '进行中', value: 1 },
        { label: '待结算', value: 2 },
        { label: '已完成', value: 3 },
        { label: '结束未传', value: 4 },
        { label: '待匹配', value: 5 },
        { label: '驳回检查', value: 6 },
        { label: '派单被司机取消', value: 7 },
        { label: '派单司机确认', value: 8 }
      ],
      poundTypeList: [
        { label: '批量上传', value: 1 },
        { label: '按趟上传', value: 2 }
      ],
      tableData: {
        list: [],
        count: 0
      },
      orderScheduleWaitSum: 0, // 待司机确认
      processingOrderScheduleSum: 0, // 进行中任务单总数
      orderScheduleAbnormalVehicleSum: 0, // 任务单异常车辆数目
      orderScheduleAbnormalOrderSum: 0, // 任务单异常运单数目
      finishUnuploadNum: 0, // 结束未传
      matchingNum: 0, // 待匹配
      rejectNum: 0, // 驳回检查
      currentDate: new Date().Format('yyyy.MM.dd'),
      startTime: new Date(new Date().Format('yyyy/MM/dd 00:00:00')).getTime(),
      endTime: new Date(new Date().Format('yyyy/MM/dd 23:59:59')).getTime(),
      enterprisenature: WUYI.getCompanyConfig.enterpriseNature //0一般1煤炭2渣土
    };
  },
  components: {
    SelectCity
  },
  filters: {
    getChedulestate(status) {
      var text = '';
      // 煤炭状态有4
      switch (status) {
        case 1:
        case 4:
          text = '进行中';
          break;
        case 2:
          text = '待结算';
          break;
        case 3:
          text = '已完成';
          break;
        default:
          break;
      }
      return text;
    },
    getPaymenttype(status) {
      var text = '';
      switch (status) {
        case 0:
          text = '余额支付';
          break;
        case 2:
          text = '账期支付';
          break;
        case 3:
          text = '线下结算';
          break;
        case 5:
          text = '企信贷';
          break;
        default:
          break;
      }
      return text;
    }
  },
  created() {
    var currentData = WUYI.currentData;
    this.isadmin = currentData.user.isadmin;
    this.companycode = currentData.company.companycode;
    this.holdercode = currentData.company.holdercode;
    this.roleRules = WUYI.currentData.userrole;
    // 获取下单人
    if (this.$store.state.placeOrder.length == 0) {
      axios.post(api.orderDataQueryPermissionUser).then(res => {
        this.roleArr = res.data;
        this.$store.dispatch('changePlace', this.roleArr);
      });
    } else {
      this.roleArr = this.$store.state.placeOrder;
    }
    this.screen();
  },
  methods: {
    //筛选查询
    screen: function () {
      // 校验时间范围
      if (!WUYI.checkDate(this.filter.startTime, this.filter.endTime)) return;
      this.cache = {
        ...this.filter,
        poundUploadType: this.filter.poundUploadType ? this.filter.poundUploadType : 0
      };
      // 在第一页时直接查询  不在第一页时通过设置currentpage来自动改变数据
      this.currentpage = 1;
      this.axiosRequest();
    },
    //分页点击
    currentChange: function (val) {
      this.currentpage = val;
      this.axiosRequest();
    },
    // 装货城市选中
    selectSourceCity(val) {
      if (val.text) {
        if (!val.areaCode) {
          this.filter.sourceCode = val.cityCode;
        } else {
          this.filter.sourceCode = val.areaCode;
        }
      } else {
        this.filter.sourceCode = '';
      }
    },
    // 卸货城市选中
    selectTargetCity(val) {
      if (val.text) {
        if (!val.areaCode) {
          this.filter.targetCode = val.cityCode;
        } else {
          this.filter.targetCode = val.areaCode;
        }
      } else {
        this.filter.targetCode = '';
      }
    },
    showDetail: function (row) {
      this.$router.push({
        name: 'TaskOrderList',
        params: { key: row.orderScheduleCode }
      });
    },
    taskDetail(row) {
      window.open(`./orderdetail.html#/task/${row.orderScheduleCode}?poundType=${row.poundUploadType}`);
    },
    handleConfirm(row) {
      this.$confirm('确认要结束该任务单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await axios.post(api.orderscheduleFinish, {
            orderScheduleCode: row.orderScheduleCode
          });
          this.$message.success('任务单已结束');
          this.screen();
          this.$store.dispatch('changeOrderCountData');
        })
        .catch(() => {});
    },
    axiosRequest: function (opts) {
      const options = {
        pageNum: this.currentpage,
        pageSize: this.pageSize,
        ...this.cache
      };
      if (options.filterState == '') options.filterState = 0;

      axios.post(api.orderSchedule, options).then(res => {
        this.tableData.list = res.data.pageResult.data || [];
        this.tableData.count = res.data.pageResult.total;
        this.processingOrderScheduleSum = res.data.processingOrderScheduleSum;
        this.orderScheduleAbnormalVehicleSum = res.data.orderScheduleAbnormalVehicleSum;
        this.orderScheduleAbnormalOrderSum = res.data.orderScheduleAbnormalOrderSum;
        this.finishUnuploadNum = res.data.finishUnuploadNum;
        this.rejectNum = res.data.rejectNum;
        this.matchingNum = res.data.matchingNum;
        this.orderScheduleWaitSum = res.data.orderScheduleWaitSum;
      });
    },
    goToAbnormalCar() {
      this.$router.push({ path: '/abnormalCar' });
    },
    goToAbnormalOrder() {
      window.location.href = `./logistics.html#/abnormalTrack?sDate=0&eDate=0&orderType=2&orderScheduleState=1`;
    }
  }
};
</script>
<style scoped>
.task-tips-con {
  background: #fdf6ec;
  border: 1px solid #f5dab1;
  height: 50px;
  line-height: 50px;
  color: #58626b;
  font-size: 14px;
  padding: 0 42px;
}
.task-tips-text-weight {
  font-weight: bold;
}
.click-link {
  cursor: pointer;
}
.click-link:hover {
  text-decoration: underline;
}
</style>
